"use client";
import Partners from "./components/Partners";

import Section from "../Section";
import Hexagons from "./Hexagons";
const styles = new Proxy({"Hero":"Hero-94b90"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

import play from "./play.svg";
import Link from "next/link";

const Hero = () => (
  <Section className={styles.Hero}>
    <div className="container">
      <div className="row pt-lg-5 pt-3 mt-3">
        <div className="col-12 text-center">
          <h1>AI Cybersecurity Platform</h1>
        </div>
        <div className="col-12 pt-3 text-center">
          <Link href="#submit" className="btn">
            Book A Demo <img src={play.src} />
          </Link>
        </div>
      </div>

      <div className="row pt-5">
        <div className="col-12 mb-lg-5">
          <Hexagons />
        </div>
      </div>
    </div>

    <Partners />
  </Section>
);

export default Hero;
